/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MediaDto } from '../../models/media-dto';
import { ReviewSource } from '../../models/review-source';

export interface CreateReviewFromEmail$Params {
  source: ReviewSource;
  customerId: number;
  email: string;
  name: string;
  rating: number;
  text: string;
  medias: Array<MediaDto>;
}

export function createReviewFromEmail(http: HttpClient, rootUrl: string, params: CreateReviewFromEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, createReviewFromEmail.PATH, 'get');
  if (params) {
    rb.query('source', params.source, {});
    rb.query('customerId', params.customerId, {});
    rb.query('email', params.email, {});
    rb.query('name', params.name, {});
    rb.query('rating', params.rating, {});
    rb.query('text', params.text, {});
    rb.query('medias', params.medias, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

createReviewFromEmail.PATH = '/api/v1/store-reviews/from-email';
